import axios from "axios";

import { baseUrl } from "./baseUrl";
import { uploadImage, updateImage } from './imageApiV2';

const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const createFact = async (data) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading fact cover image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'other', false);

            data.fileId = imageResult.imageId;
            data.fileVersion = imageResult.version;
            data.file = imageResult.url;

            console.log('✅ Fact cover image uploaded:', imageResult);
        }

        const res = await api.post("/add-fact", data);
        return res.data;
    } catch (error) {
        console.error("Error creating fact:", error);
        throw error;
    }
}

export const updateFact = async (data) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading fact cover image to Image API V2...');

            // Use updateImage if fileId exists, otherwise upload new
            let imageResult;
            if (data.fileId) {
                imageResult = await updateImage(data.fileId, data.file);
                console.log('✅ Fact cover image updated to version:', imageResult.version);
            } else {
                imageResult = await uploadImage(data.file, 'other', false);
                console.log('✅ Fact cover image uploaded:', imageResult);
            }

            data.fileId = imageResult.imageId;
            data.fileVersion = imageResult.version;
            data.file = imageResult.url;
        }

        const res = await api.put("/update-fact", data);
        return res.data;
    } catch (error) {
        console.error("Error updating fact:", error);
        throw error;
    }
}

export const getFacts = async () => {
    try {
        const res = await api.get("/fact-list");
        return res.data;
    } catch (error) {
        console.error("Error fetching facts:", error);
        throw error;
    }
}

export const deleteFact = async (id) => {
    try {
        const res = await api.delete(`/delete-fact?id=${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting fact:", error);
        throw error;
    }
}

export const getFactById = async (id) => {
    try {
        const res = await api.get(`/view-fact?id=${id}`);
        return res.data;
    } catch (error) {
        console.error("Error fetching fact by ID:", error);
        throw error;
    }
}

export const getEcoActivities = async () => {
    try {
        const res = await api.get("/eco-list");
        return res.data.ecoActivities;
    } catch (error) {
        console.error("Error fetching eco activities:", error);
        throw error;
    }
}

export const deleteEcoActivity = async (id) => {
    try {
        const res = await api.delete(`/delete-eco/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting eco activity:", error);
        throw error;
    }
}

export const getEcoActivityById = async (id) => {
    try {
        const res = await api.get(`/view-eco?id=${id}`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching eco activity by ID:", error);
        throw error;
    }
}

export const getEcoActivityCommentsById = async (data) => {
    try {
        const res = await api.post(`/list-comments`, data); // Assuming you need to send data in the body
        
        return res.data.data;
    } catch (error) {
        console.error("Error fetching eco activity Likes by ID:", error);
        throw error;
    }
}

export const updateEcoActivity = async (data) => {
    try {
        const res = await api.put("/update-eco", data);
        return res.data;
    } catch (error) {
        console.error("Error updating eco activity:", error);
        throw error;
        
    }
}

export const deleteEcoActivityComment = async (data) => {
try {
        const res = await api.post(`/delete-comment`, data); // Assuming you need to send data in the body
        
        return res.data.data;
    } catch (error) {
        console.error("Error fetching eco activity Likes by ID:", error);
        throw error;
    }
}